export default {
  title: 'Epitome Member Access',
  version: '2024.1'
};
